import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { FullscreenModal, ModalStyled } from '../../../../theme/customizedStyleComponents';
import QcReportDetails from './qcReportDetails';

export default class AddQcReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            loading: false
        };
    }

    handleShow = () => {
        this.setState({ show: true });
    };

    handleClose = () => {
        this.setState({ show: false });
        this.props.context.componentParent.loadGridData();
    };

    render() {
        return (
            <div>
                <button className="btn btn-primary button-info-grid" onClick={() => this.handleShow()}>
                    <i className="fas fa-plus"></i> Add QC Report
                </button>
                <FullscreenModal
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.show}
                    onHide={this.handleClose}
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Quality Control / QC Reports</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <QcReportDetails context={this.props.context} handleClose={this.handleClose} />
                    </Modal.Body>
                </FullscreenModal>
            </div>
        );
    }
}
